import React, { useState, createContext, SetStateAction, Dispatch, useContext } from "react";

export interface HeaderInterface {
    viewSearch: boolean;
    viewFilter: boolean;
    // page_size: number;
    max_page: number;
    current_list_page: number;
    current_loaded_page: number;
    current_song_id: number;
    current_album_id: any;
    current_artist_id: any;
    current_composer_id: any;
    current_creator_id: any;
    page_sort_order: string;
}
const HeaderContext = createContext({
    header: {} as Partial<HeaderInterface>,
    setHeader: {} as Dispatch<SetStateAction<Partial<HeaderInterface>>>,
});
const HeaderStateProvider = ({
    children,
    value = {} as HeaderInterface,
}: {
    children: React.ReactNode;
    value?: Partial<HeaderInterface>;
}) => {
    const [header, setHeader] = useState(value);
    return (
        <HeaderContext.Provider value={{ header, setHeader }}>
            {children}
        </HeaderContext.Provider>
    );
}

const useHeader = () => {
    const context = useContext(HeaderContext);
    if (!context) {
        throw new Error("useHeader must be used within HeaderContext");
    }
    return context;
};

export { HeaderStateProvider, useHeader };
